<span class="tk-pp-trigger" (click)="toggle($event)"><ng-content></ng-content></span>

@if (open) {
  <div class="tk-pp" [class.right]="align === 'right'" [class.up]="up" (click)="$event.stopPropagation()">
    <div class="tk-pp-search">
      <span class="material-symbols-outlined">search</span>
      <input #search type="text" [(ngModel)]="query" [placeholder]="placeholder" (keydown)="onKey($event)" autocomplete="off" />
    </div>
    @if (deptStrip.length) {
      <div class="tk-pp-strip">
        <span class="tk-pp-strip-label">Departments</span>
        @for (d of deptStrip; track d.name) {
          <button type="button" class="tk-pp-strip-chip" (click)="jumpTo(d)">{{ d.name | lowercase }}</button>
        }
      </div>
    }
    <div class="tk-pp-list" [style.max-height.px]="listMax">
      @if (loading) {
        <div class="tk-pp-empty">Loading people…</div>
      } @else if (!flat().length) {
        <div class="tk-pp-empty">Nobody matches “{{ query }}”</div>
      }
      @for (g of grouped; track g.label) {
        @if (g.label) {
          <div class="tk-pp-group">{{ g.label }}</div>
        }
        @for (r of g.rows; track trackRow($index, r)) {
          <button type="button" class="tk-pp-row" [class.on]="indexOf(r) === cursor" [class.chosen]="isChosen(r)" (mouseenter)="cursor = indexOf(r)" (click)="pick(r)">
            @switch (r.kind) {
              @case ('me') {
                <span class="tk-pp-ico me"><span class="material-symbols-outlined">person</span></span>
                <span class="tk-pp-main"><span class="n">Me</span><span class="s">a task for yourself</span></span>
              }
              @case ('department') {
                <span class="tk-pp-ico dept" [class.all]="r.everyone"><span class="material-symbols-outlined">{{ r.everyone ? 'diversity_3' : 'inbox' }}</span></span>
                @if (r.everyone) {
                  <span class="tk-pp-main"><span class="n">Everyone in {{ r.department.name }}</span><span class="s">one task for each of the {{ r.department.members }} people</span></span>
                } @else {
                  <span class="tk-pp-main"><span class="n">{{ r.department.name }} queue</span><span class="s">{{ r.department.heads.length ? 'one task; ' + r.department.heads.join(', ') + ' hands it to someone' : 'one task; anyone in the department picks it up' }}</span></span>
                }
              }
              @case ('person') {
                <tk-avatar [person]="r.person" [size]="26"></tk-avatar>
                <span class="tk-pp-main"><span class="n">{{ r.person.name }}</span><span class="s">{{ r.person.department | lowercase }}</span></span>
              }
            }
          </button>
        }
      }
    </div>
  </div>
}
